<template>
  <div class="armor-dummy">
    <div class="armor-layers">
      <!-- Base dummy -->
      <img src="/img/forge_dummy/Dummy.png" alt="1" class="layer base-layer" />

      <!-- Armor layers (rendered on top) -->
      <img v-if="feets" :src="getArmorImage(feets)" alt="Feets" class="layer armor-layer" />
      <img v-if="legs" :src="getArmorImage(legs)" alt="Legs" class="layer armor-layer" />
      <img v-if="torso" :src="getArmorImage(torso)" alt="Torso" class="layer armor-layer" />
      <img v-if="head" :src="getArmorImage(head)" alt="Head" class="layer armor-layer" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ArmorDummy',
  components: {
  },
  props: {
    head: {
      type: String,
      required: false,
      default: null,
    },
    torso: {
      type: String,
      required: false,
      default: null,
    },
    legs: {
      type: String,
      required: false,
      default: null,
    },
    feets: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
  },
  methods: {
    getArmorImage(value) {
      try {
        return `/img/forge_dummy/${value}.png`;
      } catch (e) {
        console.warn(`dummy image not found: ${value}.png`);
        return null;
      }
    },
  },
};
</script>
<style scoped>
.armor-dummy {
  width: 100%;
  height: 100%;
  margin: 0 auto;
}

.armor-layers {
  position: relative;
  width: 100%;
  height: 100%;
  aspect-ratio: 1 / 2; /* 1000x2000 = 1:2 ratio */
}

.layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.base-layer {
  z-index: 1;
}

.armor-layer {
  z-index: 2;
}

/* Mobile optimization */
@media (max-width: 768px) {
  .armor-dummy {
    max-width: 100%;
    padding: 0 1rem;
  }
}
</style>
